module.exports = __webpack_public_path__ + "static/media/logoblue.9c7ffd63.png";